// src/lib/gpMode.ts (2026-08-24 新設)
//
// 正式版 GP の単一真実源。
//
//   2026-08-25 に /theta で検証した新定義を正式版へ昇格した。
//   全画面で GP = 薬剤材料費差引後入院収入 − 医師人件費 とし、
//   画面表記も「粗利」ではなく「GP」に統一する。
//
// ★実装のかたち
//   - 数字: 全 API 呼び出しに `X-GP-Mode: jinken` を付ける (lib/api.ts の jsonFetch が一括付与)。
//     server は同じ本番 DB を「新GP定義の TEMP VIEW」で読むコネクションに切り替える。
//     → **別 DB も別バンドルも要らない**。
//   - 表記: 「粗利」→「GP」を gpText() で置換する。
export const IS_GP = true;

/** /theta は旧開発版 URL のブックマーク互換としてのみ残す。 */
export const IS_THETA_ROUTE =
  typeof window !== "undefined" && window.location.pathname.startsWith("/theta");

/**
 * 既存 component の版分岐との互換名。現在は全画面が新GPなので常に true。
 * 新規コードでは IS_GP を使う。
 */
export const IS_THETA = IS_GP;

/** API に付ける正式 GP モードヘッダ。 */
export const GP_MODE_HEADER: Record<string, string> = { "X-GP-Mode": "jinken" };

/**
 * 画面表記の旧語「粗利」を正式名称「GP」に読み替える。
 *   粗利 → GP / 1日粗利単価 → 1日GP単価 / 粗利率 → GP率 / 粗利分析 → GP分析
 * いずれも「粗利」の 2 文字を置換するだけで成立するので単純置換でよい。
 */
export const gpText = (s: string): string => s.replaceAll("粗利", "GP");

/** 正式 GP の 1 行説明。 */
export const THETA_GP_DEF =
  "GP = 薬剤材料費差引後入院収入 − 医師人件費（= 入院収入 − 出来高換算薬剤費 − 出来高換算材料費 − 医師人件費）";
